import React, { lazy, Suspense } from 'react';

const LazyNotificationList = lazy(() => import('./Notification'));

const NotificationList = (
  props: JSX.IntrinsicAttributes & { children?: React.ReactNode }
) => (
  <Suspense fallback={null}>
    <LazyNotificationList {...props} />
  </Suspense>
);

export default NotificationList;
